import request from "@/utils/request";

// 浮窗侧边栏管理详情
export function floatingDetail() {
  return request({
    url: "/adminApi/sys/sidebar/detail",
    method: "post"
  })
}

// 浮窗侧边栏管理编辑
export function floatEdit(data) {
  return request({
    url: "/adminApi/sys/sidebar/modify",
    method: "post",
    data: data
  })
}
